export const environment = {
  production: false,
  apiUrl: 'https://app-update-stage.keck-atlas.de',
  //wegweiserApiUrl: 'https://www.wegweiser-kommune.de/data-api/rest',
  wegweiserApiUrl: '/data-api/rest', // Backend proxy is used
};
